const YOUTUBE_VIDEO_ID_PATTERN = /^[\w-]{11}$/;

const stripLeadingWww = (host: string) => host.replace(/^www\./i, '');

const normalizeHtmlUrl = (value: string) =>
  value.replace(/&amp;/gi, '&').replace(/&quot;/gi, '"').trim();

const extractVideoIdFromUrl = (rawUrl: string): string | null => {
  let url: URL;
  try {
    url = new URL(normalizeHtmlUrl(rawUrl));
  } catch {
    return null;
  }

  const hostname = stripLeadingWww(url.hostname.toLowerCase());
  if (hostname === 'youtu.be') {
    const shortId = url.pathname.split('/').filter(Boolean)[0] ?? '';
    return YOUTUBE_VIDEO_ID_PATTERN.test(shortId) ? shortId : null;
  }

  if (hostname !== 'youtube.com' && hostname !== 'm.youtube.com') {
    return null;
  }

  const watchId = url.searchParams.get('v');
  if (watchId && YOUTUBE_VIDEO_ID_PATTERN.test(watchId)) {
    return watchId;
  }

  const pathParts = url.pathname.split('/').filter(Boolean);
  if (pathParts.length < 2) {
    return null;
  }

  const [prefix, maybeId] = pathParts;
  if (
    (prefix === 'shorts' || prefix === 'embed' || prefix === 'live') &&
    YOUTUBE_VIDEO_ID_PATTERN.test(maybeId)
  ) {
    return maybeId;
  }

  return null;
};

const extractUrlsFromHtml = (html: string): string[] => {
  const urls = new Set<string>();
  const hrefPattern = /href=(['"])(.*?)\1/gi;
  let hrefMatch = hrefPattern.exec(html);
  while (hrefMatch) {
    urls.add(hrefMatch[2]);
    hrefMatch = hrefPattern.exec(html);
  }

  const plainUrlPattern = /https?:\/\/[^\s<>"']+/gi;
  let plainMatch = plainUrlPattern.exec(html);
  while (plainMatch) {
    urls.add(plainMatch[0]);
    plainMatch = plainUrlPattern.exec(html);
  }

  return Array.from(urls);
};

export const getYouTubeEmbedUrl = (content: string): string | null => {
  for (const url of extractUrlsFromHtml(content)) {
    const videoId = extractVideoIdFromUrl(url);
    if (videoId) {
      return `https://www.youtube-nocookie.com/embed/${videoId}`;
    }
  }

  return null;
};

